module.exports = __webpack_public_path__ + "static/media/instagram.70b6ecc5.svg";